(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('TableModalController', ["$scope", "$modalInstance", "args", "tablePaginationHelper", "systemTasksService", function ($scope, $modalInstance, args, tablePaginationHelper, systemTasksService) {
        $scope.args = $.extend({
            title: 'Table dialog',
            okText: 'Ok'
        }, args);
        $scope.tableHelper = tablePaginationHelper($scope, $scope.args.tableOptions, $scope.args.options, function (args) {
            return $scope.args.retrieve(args);
        }, function (tableModel) {
            $scope.tableModel = tableModel;
            if ($scope.args.loading) {
                $scope.args.loading = false;
            }
        });
        _($scope.args.on).each(function (listener, eventName) {
            $scope.$on(eventName, function (event, data) {
                listener(event, data, $scope);
            });
        });
        $scope.cancel = function () {
            $modalInstance.dismiss();
        };
        $scope.ok = function () {
            $modalInstance.close($scope.tableHelper.getSelected());
        };
        $scope.haveSelection = function () {
            return $scope.tableHelper.getSelected().length > 0;
        };
        if (args.closeOnNavigate) {
            $scope.$on('$routeChangeSuccess', function (event, data) {
                $modalInstance.dismiss();
            });
        }
        $scope.executeButton = function (button) {
            if (!button.noDismiss) {
                $modalInstance.dismiss();
            }
            if (button.execute) {
                button.execute();
            }
        };
        if ($scope.args && $scope.args.buttons && $scope.args.buttons.length) {
            _($scope.args.buttons).each(function (button) {
                if (button.id === 'refresh') {
                    button.execute = function () {
                        if ($scope.tableHelper) {
                            button.class = 'btn-no-border fa fa-refresh fa-spin';
                            $scope.tableHelper.reload(true, false).then(function () {
                                button.class = 'btn-no-border fa fa-refresh';
                            });
                        }
                    };
                }
            });
        }
        function changeBtnStatus(id, status) {
            if ($scope.args && $scope.args.buttons && $scope.args.buttons.length) {
                _($scope.args.buttons).each(function (button) {
                    if (button.id === id) {
                        button.disable = status;
                    }
                });
            }
        }
        $scope.$on('do-refresh-actions-modal-title', function (event, data) {
            $scope.args.title = systemTasksService.makeTitle(data.title, data.status);
        });
        $scope.refresh = function () {
            $scope.isRefreshing = true;
            $scope.tableHelper.reload(true, false).then(function () {
                $scope.isRefreshing = false;
            });
        };
        $scope.$on('change-btn-status-table-modal', function (event, data) {
            changeBtnStatus(data.id, data.disable);
        });
    }]);
    m.factory('tableModal', ["$modal", "path", function ($modal, path) {
        return {
            show: function (args, size) {
                if (!_(args).isObject()) {
                    args = { message: args };
                }
                var modalConfig = {
                    templateUrl: path('common').ctrl('table-modal').template(),
                    controller: 'TableModalController',
                    size: size,
                    resolve: { args: _.constant(args) }
                };
                if (args && args.windowClass) {
                    modalConfig.windowClass = args.windowClass;
                }
                if (_(args).isObject() && !_(args.backdrop).isUndefined()) {
                    modalConfig.backdrop = args.backdrop;
                }
                if (_(args).isObject() && !_(args.keyboard).isUndefined()) {
                    modalConfig.keyboard = args.keyboard;
                }
                var modalInstance = $modal.open(modalConfig);
                return modalInstance.result;
            }
        };
    }]);
}());